import useReactiveZone from "reactive-zone";
import FieldModel from "../../models/FieldModel.js";
import TaiBaseWidget from "../base.widget.js";

import multiChoiceTemplate from './MultiChoice.template.html'

class MultiChoiceWidget extends TaiBaseWidget {

    onZoneInit() {
        const { injectMethodToZone, injectPropToZone, useElementRefList, onZoneReady } = useReactiveZone(this);

        const props = injectPropToZone({
            counter: new Date().getTime().toString()
        })

        injectMethodToZone({
            clearValue: this.clearValue.bind(this)
        })

    }

    template() {
        return multiChoiceTemplate
    }

    clearValue() {
        this.inputControls.forEach(item => item.checked = false)
    }

    getValue() {
        return this.fieldModel.userResponse;
    }

    clearValue() {
        this.fieldModel.userResponse = [];
    }
}

export default MultiChoiceWidget;